import { Reveal, SectionHeading } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is A2 Gir Cow Ghee?",
    a: "It is ghee made from the milk of Gir cows — an indigenous Indian breed whose milk naturally contains the A2 type of beta-casein protein. MAHIRA ghee is prepared with traditional inspiration and packed to a premium standard.",
  },
  {
    q: "What is the Bilona method?",
    a: "Bilona is the traditional Indian way of making ghee: milk is first set into curd, the curd is hand-churned with a wooden bilona to separate the butter (makhan), and the butter is then slow-heated into pure, aromatic ghee. MAHIRA A2 Gir Cow Ghee is made using this method.",
  },
  {
    q: "What makes Gir cow milk different?",
    a: "The Gir is a desi (indigenous) breed from the Gir forest region of Gujarat. Its milk is known for its rich taste and naturally contains the A2 type of beta-casein protein.",
  },
  {
    q: "How should MAHIRA ghee be stored?",
    a: "Store the jar in a cool, dry place away from direct sunlight. Always use a clean, dry spoon. Ghee does not require refrigeration.",
  },
  {
    q: "How can I order MAHIRA A2 Gir Cow Ghee?",
    a: "Simply message us on WhatsApp or call +91 97737 56768. We will confirm your preferred size, the current price and delivery details — personally.",
  },
  {
    q: "Where does MAHIRA deliver?",
    a: "We currently serve Navi Mumbai and the wider Mumbai region, and we are expanding across India. Message us on WhatsApp with your PIN code and we will confirm delivery to your area.",
  },
  {
    q: "What sizes are available?",
    a: "MAHIRA A2 Gir Cow Ghee is available in 250 ml, 500 ml and 1 L premium glass jars. The 500 ml jar is ₹1,150 MRP — currently ₹850 under our Independence Day offer (till 15 August). Pricing for the 250 ml and 1 L jars is shared on enquiry.",
  },
  {
    q: "How can I become a MAHIRA distributor?",
    a: "Send us a Distributor Enquiry on WhatsApp with your city and business details. Our team will reach out with partnership terms.",
  },
  {
    q: "Do you offer wholesale orders?",
    a: "Yes. Retailers, restaurants and bulk buyers can use the Wholesale Enquiry option on WhatsApp to receive bulk pricing and terms.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-ivory py-24 md:py-32">
      <div className="mx-auto max-w-4xl px-5 md:px-10">
        <SectionHeading eyebrow="Questions" title="Frequently Asked Questions" />
        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-14" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="border-forest/10"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i + 1}`}
                  className="py-6 text-left font-heading text-xl text-forest transition-colors duration-300 hover:text-gold hover:no-underline md:text-2xl"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-answer-${i + 1}`}
                  className="pb-7 text-sm leading-relaxed text-charcoal/70 md:text-base"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
